import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm$wine;
  var _vm = this,
    _c = _vm._self._c;
  return ((_vm$wine = _vm.wine) === null || _vm$wine === void 0 || (_vm$wine = _vm$wine.discounts) === null || _vm$wine === void 0 ? void 0 : _vm$wine.length) > 0 && !!_vm.currency ? _c("div", {
    staticClass: "discount-card"
  }, [_c(VMenu, {
    attrs: {
      top: "",
      "offset-y": "",
      "open-on-hover": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var _vm$wine$discounts;
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          staticClass: "dfwa-btn --small-2 discount-btn"
        }, "v-btn", attrs, false), on), [_c("span", {
          staticClass: "discount-label"
        }, [_vm._v("Case deal" + _vm._s(((_vm$wine$discounts = _vm.wine.discounts) === null || _vm$wine$discounts === void 0 ? void 0 : _vm$wine$discounts.length) > 1 ? "s" : ""))])])];
      }
    }], null, false, 3182004558)
  }, [_c(VList, {
    staticClass: "discount-list",
    attrs: {
      rounded: ""
    }
  }, [_vm._l(_vm.wine.discounts, function (discount, index) {
    return _c(VListItem, {
      key: index
    }, [_c(VListItemTitle, [index !== 0 ? _c(VDivider, {
      staticClass: "item-divider"
    }) : _vm._e(), _vm._v(" " + _vm._s("By ".concat(Math.floor(discount.bottle_treshold), " bottles : ").concat(_vm.displayPrice(discount.customerPriceIncludeDefaultShippingCurrency, discount.currency))) + " "), _c("span", {
      staticClass: "additional-info"
    }, [_vm._v(_vm._s(_vm.displayPrice(_vm.wine.customerPriceIncludeDefaultShippingCurrency - discount.customerPriceIncludeDefaultShippingCurrency, discount.currency)))])], 1)], 1);
  }), _vm.isAdminNotConsultant() ? _c(VListItem, [_c(VListItemTitle, [_c(VDivider, {
    staticClass: "item-divider"
  }), _c("div", {
    staticClass: "text-smaller text-center mt-2 mb-1"
  }, [_vm._v(" " + _vm._s("By <".concat(Math.floor(_vm.wine.discounts[0].bottle_treshold), " bottles : ")) + " "), _c("span", {
    staticClass: "text-bold"
  }, [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.wine.customerPriceIncludeDefaultShippingCurrency, _vm.currency)) + " ")])])], 1)], 1) : _vm._e()], 2)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };